<script>
import { BFormTags } from "bootstrap-vue";

export default {
  extends: BFormTags
};
</script>